import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';

/**
 * Execute a function conditional on when a DOM ref intersects the viewport via IntersectionObserver
 * @param onInView - the function to execute when the element is in view
 * @param config - optional config consumed by `react-intersection-observer`
 */
export function useOnInView(
  onInView: () => void,
  config: Parameters<typeof useInView>[0] = {}
) {
  const {ref, inView} = useInView({
    fallbackInView: true, // in the event IntersectionObserver is not supported, execute the callback immediately
    ...config,
  });

  useEffect(() => {
    if (inView) {
      onInView();
    }
  }, [inView, onInView]);

  return ref;
}
